<div class="step-three" [class.step-three--edit]="isEditStepper">
  <div class="step-three__layout">
    <div class="step-three__back">
      <ds-button-v2
        emphasis="terciary"
        size="xs"
        leadingIcon="ArrowBack"
        [label]="isEditStepper ? stepThree.editBack : stepThree.back"
        (clicked)="goBack()"
      ></ds-button-v2>
    </div>

    <div class="step-three__columns">
      <div class="step-three__primary">
        <div class="step-three__heading">
          <p class="step-three__flow">{{ stepThree.flowName }}</p>
          <div class="step-three__heading-text">
            <h2 class="step-three__title">{{ isEditStepper ? stepThree.editTitle : stepThree.title }}</h2>
            <p class="step-three__subtitle">{{ stepThree.subtitle }}</p>
          </div>
        </div>

        <ds-card shadow="l2">
          <section class="step-three__card">
            <div class="step-three__card-header">
              <h3 class="step-three__card-title">{{ stepThree.cardTitle }}</h3>
              <p class="step-three__card-subtitle">{{ stepThree.cardSubtitle }}</p>
            </div>

            <div class="step-three__options">
              <div
                *ngFor="let employer of employers"
                class="step-three__option"
                [class.step-three__option--selected]="isSelected(employer)"
              >
                <button
                  type="button"
                  class="step-three__option-header"
                  [attr.aria-pressed]="isSelected(employer)"
                  (click)="select(employer)"
                >
                  <span class="step-three__radio" aria-hidden="true"></span>
                  <span class="step-three__option-title">{{ employer.name }}</span>
                </button>

                <div *ngIf="isSelected(employer)" class="step-three__option-details">
                  <dl class="step-three__employer-data">
                    <div *ngFor="let detail of employer.details" class="step-three__employer-item">
                      <dt class="step-three__employer-label">{{ detail.label }}</dt>
                      <dd class="step-three__employer-value">{{ detail.value }}</dd>
                    </div>
                  </dl>

                  <div class="step-three__email">
                    <div class="step-three__search step-three__search--labeled">
                      <ds-input-text
                        class="step-three__search-field"
                        type="email"
                        [label]="stepThree.emailLabel"
                        [placeholder]="stepThree.emailPlaceholder"
                        [value]="employer.email"
                        [disabled]="employer.emailSaved"
                        [state]="isEmailInvalid(employer) ? 'error' : 'default'"
                        [helpText]="stepThree.emailError"
                        [showHelpText]="isEmailInvalid(employer)"
                        (valueChange)="onEmailInput(employer, $event)"
                        (blurred)="onEmailBlur(employer)"
                      ></ds-input-text>

                      <div class="step-three__search-action">
                        <ds-button-v2
                          emphasis="secondary-outlined"
                          size="s"
                          [fullWidth]="true"
                          maxWidth="100%"
                          [disabled]="!canToggleEmail(employer)"
                          [label]="employer.emailSaved ? stepThree.emailUpdateButton : stepThree.emailButton"
                          (clicked)="toggleEmail(employer)"
                        ></ds-button-v2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </ds-card>

        <div class="step-three__submit">
          <div class="step-three__submit-action">
            <ds-button-v2
              emphasis="primary"
              size="m"
              [fullWidth]="true"
              maxWidth="100%"
              [disabled]="!canContinue"
              [label]="isEditStepper ? stepThree.editSubmit : stepThree.submitButton"
              (clicked)="isEditStepper ? saveChanges() : goToNextStep()"
            ></ds-button-v2>
          </div>
        </div>
      </div>

      <app-stepper-lateral
        *ngIf="!isEditStepper"
        class="step-three__stepper"
        [currentStep]="currentStepIndex"
      ></app-stepper-lateral>
    </div>
  </div>
</div>
